export enum TabsKey {
	LICENSE = 'license',
	QUESTIONS = 'questions',
}

export const tabOptions = [
	{
		title: 'Лицензии',
		key: TabsKey.LICENSE,
	},
	{
		title: 'Часто задаваемые вопросы',
		key: TabsKey.QUESTIONS,
	},
]
